"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreCollapsibleContainer = require("@vfuk/core-collapsible-container");

var _uuid = require("uuid");

var _coreLink = _interopRequireDefault(require("@vfuk/core-link"));

var _coreDivider = _interopRequireDefault(require("@vfuk/core-divider"));

var _coreListItem = _interopRequireDefault(require("@vfuk/core-list-item"));

var Styled = _interopRequireWildcard(require("./styles/MobileLinkList.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MobileLinkList = function MobileLinkList(_ref) {
  var linkGroups = _ref.linkGroups,
      onInteractionClick = _ref.onInteractionClick;
  return /*#__PURE__*/_react["default"].createElement(Styled.MobileLinkListWrapper, null, linkGroups.groups.map(function (group, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: (0, _uuid.v4)()
    }, /*#__PURE__*/_react["default"].createElement(_coreCollapsibleContainer.CollapsibleContainer, {
      appearance: "primary",
      inverse: true,
      isActive: linkGroups.openOnMD
    }, /*#__PURE__*/_react["default"].createElement(_coreCollapsibleContainer.CollapsibleContainerHeader, null, group.headingText), /*#__PURE__*/_react["default"].createElement(_coreCollapsibleContainer.CollapsibleContainerBody, {
      key: (0, _uuid.v4)()
    }, /*#__PURE__*/_react["default"].createElement(Styled.LinkListWrapper, null, group.links.map(function (link) {
      return /*#__PURE__*/_react["default"].createElement(_coreListItem["default"], {
        key: link.id
      }, /*#__PURE__*/_react["default"].createElement(_coreLink["default"], {
        inverse: true,
        srText: link.srText,
        href: link.url,
        to: link.to,
        htmlAttributes: {
          dataAttributes: link.dataAttributes
        },
        onClick: onInteractionClick
      }, link.text));
    })))), index !== linkGroups.groups.length - 1 ? /*#__PURE__*/_react["default"].createElement(_coreDivider["default"], {
      appearance: "secondary",
      inverse: true
    }) : null);
  }));
};

MobileLinkList.displayName = "MobileLinkList";
var _default = MobileLinkList;
exports["default"] = _default;
//# sourceMappingURL=MobileLinkList.js.map